<template>
  <div class="video-page-wrapper">
    <img style="height: 73vh" src="@/assets/pages/doorbell.png" alt="img" />
    <PageTabs>
      <template v-slot:first>
        <div>
          <div class="video-page-texts video-page-texts-no-offset">
            <div>
              <h3>{{ $t("pages.doorbells.subtitle1") }}</h3>
              <p>{{ $t("pages.doorbells.text1") }}</p>
            </div>
          </div>
          <ProductsRow :products="products"></ProductsRow>
        </div>
      </template>
      <template v-slot:second>
        <VoiceCommands :commands="commands"></VoiceCommands>
      </template>
    </PageTabs>
  </div>
</template>

<script>
import PageTabs from "../components/PageTabs";
import VoiceCommands from "../components/VoiceCommands";
import ProductsRow from "../components/ProductsRow";
export default {
  name: "Doorbells",
  components: { ProductsRow, VoiceCommands, PageTabs },
  data() {
    return {
      commands: this.$t("pages.doorbells.commands"),
      products: [
        { img: "doorbells/doorbell-circle.png", text: "Logitech Circle", price: "164" },
        { img: "doorbells/doorbell-netatmo.png", text: "Netatmo", price: "250" },
        { img: "doorbells/doorbell-robin.png", text: "Robin ProLine", price: "696" },
        { img: "doorbells/doorbell-yobi.png", text: "Yobi", price: "164" }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.img-music {
  width: 100%;
  max-width: 200px;
}
</style>
